import api from '../../../services/Api';
import { IAuditoriaLancamentoDiaNaoUtilResultado } from '../interfaces/IAuditoriaLancamentoDiaNaoUtil';

export const AuditoriaLancamentoDiaNaoUtilService = {
  async buscarResultado(params: {
    empresaId: number;
    periodo?: string;
  }): Promise<IAuditoriaLancamentoDiaNaoUtilResultado> {
    const response = await api.get<IAuditoriaLancamentoDiaNaoUtilResultado>('auditoria-lancamento-dia-nao-util/resultado', {
      params: {
        empresaIds: params.empresaId,
        periodo: params.periodo || '',
      },
    });

    return (
      response.data || {
        impactoFiscalTotal: 0,
        impactoFinanceiroTotal: 0,
        totalAvisos: 0,
        totalAlertas: 0,
        totalErros: 0,
        totalLancamentosAnalisados: 0,
        status: 'CONCILIADO',
        mensagemDirecionamento: '',
        fundamentacaoContabil: '',
        lancamentosDiaNaoUtil: [],
      }
    );
  },
};
